import { AppRouter } from './routers/app.router';

const App = () => (
    <AppRouter />
);

export default App;
